import React, { Component } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';

class Footer extends Component {
  render() {
    return (
      <div className="Footer">
        <div className="Brake"></div>
        <p className="Brand Bungee Center Red">CALL US NOW!</p>
        <p className="BrandSm Bungee Center Cyan">Or Email to Learn More</p>
        <div className="FullSizeTable">
          <div className="Container">
            <p className="Blue InfoText Titillium Center">Phone:<br />(785)813-7921<br />Email:<br />ziyad@heartlandfun.com</p>
          </div>
          <div className="Container">
            <p className="Blue InfoText Titillium Center">Available: <br />Monday-Sunday<br />9:00 a.m. to 5:00 p.m<br /></p>
          </div>
          <div className="Container">
            <p className="Blue InfoText Titillium Center">Address:<br />2416 Ponderosa, Dr 66049, <br />Lawrence, KS</p>
          </div>
        </div>

        <a href="/games" className="SmallButton FooterWidthFix">See Our Products</a>
        <iframe className="Map Center" sandbox="allow-scripts allow-popups allow-forms allow-same-origin allow-popups-to-escape-sandbox allow-downloads allow-modals allow-storage-access-by-user-activation" frameborder="0" aria-label="Map, 2416 Ponderosa Dr" src="https://maps-api-ssl.google.com/maps?hl=en-US&amp;ll=38.939938,-95.218975&amp;output=embed&amp;q=2416+Ponderosa+Dr,+Lawrence,+KS+66046,+USA+(2416+Ponderosa+Dr)&amp;z=16" allowfullscreen=""></iframe>
        <div></div>
        <p></p>
        <div className="social-media-buttons">
          <a href="tel:17858137921" className="social-btn phone">
            <i className="fas fa-phone-alt"></i> {/* Phone Icon */}
          </a>
          <a href="mailto:heartlandfun23@gmail.com" className="social-btn email">
            <i className="fas fa-envelope"></i> {/* Email Icon */}
          </a>
          <a href="sms:17858137921" className="social-btn sms">
            <i className="fas fa-sms"></i> {/* SMS Icon */}
          </a>
          <a href="https://maps.app.goo.gl/4LhCpE2ppQ3aEHQL9" className="social-btn maps">
            <i className="fas fa-map-marker-alt"></i> {/* Apple Maps Icon */}
          </a>
          <a href="https://maps.app.goo.gl/1LCAU675gXtbbfCm6" className="social-btn facebook">
            <i className="fab fa-facebook-f"></i> {/* Facebook Icon */}
          </a>
          <a href="https://api.whatsapp.com/send/?phone=17853834150&text&type=phone_number&app_absent=0" className="social-btn whatsapp">
            <i className="fab fa-whatsapp"></i> {/* WhatsApp Icon */}
          </a>
          <a href="https://www.instagram.com/heartland.fun" className="social-btn instagram">
            <i className="fab fa-instagram"></i> {/* Instagram Icon */}
          </a>
          <a href="https://www.ebay.com/usr/heartl16" className="social-btn ebay">
            <i className="fab fa-ebay"></i> {/* eBay Icon */}
          </a>
          <a href="https://www.snapchat.com/add/heartlandfun?invite_id=V2ZyGQyu&locale=en_US&share_id=nAt25-WrQpSigM2NFWF9aQ&sid=9052642aa22244cd8d1273c1e62a9e74" className="social-btn snapchat">
            <i className="fab fa-snapchat"></i> {/* Snapchat Icon */}
          </a>
          <a href="https://www.youtube.com/@HeartlandFun" className="social-btn youtube">
            <i className="fab fa-youtube"></i> {/* YouTube Icon */}
          </a>
        </div>
        <p style={{ textAlign: "center" }}>
          Site made and hosted by<a className="Footer" href="https://csfrederick.com">Jack Frederick</a>
        </p>
      </div>

    );
  }
}

export default Footer;
